export const MODEL_ROUTE = '/healthcare-sites';
